import React, {Dispatch, SetStateAction} from "react";
import ModalWrapper from "components/UI/Modal/ModalWrapper";

export interface IModal {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export interface IModalProps extends IModal {}

const Modal: React.FC<IModalProps> = (
    {
        isOpen,
        setIsOpen
    }
) => {
    return (
        <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen}>
            <div onClick={(e) => {
                e.stopPropagation()
            }} className="modal__content subscribe-content">
                <button className="modal__btn-close" onClick={() => {setIsOpen(false)}}>Close</button>
                <iframe src="https://cdn.forms-content.sg-form.com/659ec682-e704-11ec-b68b-aa8156913d28"></iframe>
                
            </div>
        </ModalWrapper>
    );
};

export default Modal;